enum SnackbarStatus {
  NONE,
  LOADING,
  SUCCESS,
  ERROR,
}

export default SnackbarStatus;
